// extracted by mini-css-extract-plugin
export default {"destination":"Tireur_destination__4iJoF","preview":"Tireur_preview__yFqZ-","category":"Tireur_category__lYSQA","title":"Tireur_title__BqlOo","content":"Tireur_content__+MtEc"};